import React from 'react';
import { useTheme } from '../context/ThemeContext';

const FolderItem = ({ name, isOpen, hasArrow, onClick }) => {
  const { colors } = useTheme();
  return (
    <div
      className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity"
      onClick={onClick}
    >
      {/* Folder Icon */}
      <div
        className="mt-1 flex-shrink-0"
        style={{
          width: '19px',
          height: '16px',
          backgroundColor: colors.textPrimary,
          maskImage: `url(${isOpen ? "/folders/folder-open.svg" : "/folders/folder-closed.svg"})`,
          WebkitMaskImage: `url(${isOpen ? "/folders/folder-open.svg" : "/folders/folder-closed.svg"})`,
          maskSize: 'contain',
          WebkitMaskSize: 'contain',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat'
        }}
      />

      {/* Folder Name */}
      <span className="text-[20px] leading-none" style={{ color: colors.textPrimary }}>
        {name}
      </span>

      {/* Arrow Icon - Only show when folder is open */}
      {hasArrow && isOpen && (
        <div
          className="flex-shrink-0 ml-1"
          style={{
            width: '12px',
            height: '12px',
            backgroundColor: colors.textPrimary,
            maskImage: 'url(/open.svg)',
            WebkitMaskImage: 'url(/open.svg)',
            maskSize: 'contain',
            WebkitMaskSize: 'contain',
            maskRepeat: 'no-repeat',
            WebkitMaskRepeat: 'no-repeat'
          }}
        />
      )}
    </div>
  );
};

export default FolderItem;
